import { Button } from "@EspaceParkQC/sdk-react";

export default function Phonepad({
  onKeyPress,
  isAvailable,
}: {
  onKeyPress: (digit: string) => void | Promise<void>;
  isAvailable: boolean;
}): React.ReactElement {
  return (
    <div className="w-full flex flex-col items-center gap-4">
      <div className="grid grid-cols-3 gap-3 w-full max-w-md">
        {[
          { digit: "1", letters: "" },
          { digit: "2", letters: "ABC" },
          { digit: "3", letters: "DEF" },
          { digit: "4", letters: "GHI" },
          { digit: "5", letters: "JKL" },
          { digit: "6", letters: "MNO" },
          { digit: "7", letters: "PQRS" },
          { digit: "8", letters: "TUV" },
          { digit: "9", letters: "WXYZ" },
          { digit: "*", letters: "" },
          { digit: "0", letters: "+" },
          { digit: "#", letters: "" },
        ].map(({ digit, letters }) => (
          <Button
            key={digit}
            onClick={(e) => {
              e.preventDefault();
              onKeyPress(digit);
            }}
            disabled={!isAvailable}
            variant="outline"
            size="lg"
          >
            <span>{digit}</span>
            {letters && <span className="text-xs font-normal text-muted-foreground">{letters}</span>}
          </Button>
        ))}
      </div>
    </div>
  );
}
